//************************************************************
//Component to render the table starts here
import React, { Fragment } from 'react';

import { FormattedMessage } from 'react-intl/dist';
import TooltipUser from '../common/tooltip/ScreenpopTooltip';

import { BLOOD_RELATIONSHIP_CODES } from '../../constants/ssap/hhmTypes/bloodRelationshipCodesList';


const ScreenpopTable = props => {

    const {
        authenticatedCallerGuid,
        confirmedCaller,
        filterTableHeadersConfig,
        handleConfirmCaller,
        handleGoToHouseHold,
        filteredUserData: userObj,
        isChatAuth
    } = props;



    //************************************************************
    //function to render the table
    const tableHeader = () => {

        return (
            <thead>
                <tr>
                    {filterTableHeadersConfig.map((obj, index) => {
                        return(
                            <th key={`table-header-${index}`}>
                                <FormattedMessage id={`screenpop.table.header.${obj.stateName}`}/>
                            </th>);
                    })}
                </tr>
            </thead>
        );
    };
    //end of table header function
    //************************************************************


    //************************************************************
    //function to render the body of the table
    const tableBody = (filteredUserData) => {

        //************************************************************
        //function to render each row of user data
        const userRow = (rowObj, index) => {
            
            const primaryApplicantGuid = (rowObj.applicants && rowObj.applicants.length) ? rowObj.applicants.filter(a => (a.relationship === BLOOD_RELATIONSHIP_CODES.SELF))[0].applicantGuid : null;

            const primaryContactName = `${rowObj.primaryContact.firstName} ${rowObj.primaryContact.lastName}`;
            const brokerName = rowObj.broker ? `${rowObj.broker.firstName} ${rowObj.broker.lastName}` : null;
            const assisterName = rowObj.assister ? `${rowObj.assister.firstName} ${rowObj.assister.lastName}` : null;
            const authRepName = (('authRep' in rowObj) && Object.keys(rowObj.authRep).length) ? `${rowObj.authRep.firstName} ${rowObj.authRep.lastName}` : null;
            let singleApplicant = (('applicants' in rowObj) && rowObj.applicants.length === 1) ? `${rowObj.applicants[0].firstName} ${rowObj.applicants[0].lastName}` : null;
            let tempIndex = index;
            let arrayOfApplicants;

            //remove primary applicant if they are in the applicants array
            if('applicants' in rowObj) {
                arrayOfApplicants = rowObj.applicants.filter(appObj => {
                    return appObj.relationship !== '18';
                });

                if(arrayOfApplicants.length === 1) {
                    singleApplicant = `${arrayOfApplicants[0].firstName} ${arrayOfApplicants[0].lastName}`;
                }
            }


            return(
                <Fragment key={`userRow-data-fragment-${index}`}>
                    <td>
                        {TooltipUser('screenpop', primaryContactName, rowObj.primaryContact, 'member', ++tempIndex, 'pc', undefined, undefined, undefined, authenticatedCallerGuid, primaryApplicantGuid, isChatAuth)}
                    </td>
                    <td>
                        {( ('applicants' in rowObj) && arrayOfApplicants.length) ?
                            <Fragment key={`applicants-${index}`}>
                                {
                                    !singleApplicant ?
                                        arrayOfApplicants.map(obj => {
                                            return TooltipUser('screenpop', `${obj.firstName} ${obj.lastName}`, obj, 'member', ++tempIndex, rowObj.externalCaseId, undefined, undefined, undefined, authenticatedCallerGuid, obj.applicantGuid);
                                        }) : TooltipUser('screenpop', singleApplicant, rowObj.applicants[0], 'member', ++tempIndex, rowObj.externalCaseId, undefined, undefined, undefined, authenticatedCallerGuid, arrayOfApplicants[0].applicantGuid)
                                }
                            </Fragment> :
                            null
                        }
                    </td>
                    <td>
                        {
                            brokerName &&
                            TooltipUser('screenpop', brokerName, rowObj.broker, 'broker', ++tempIndex, rowObj.externalCaseId,  confirmedCaller,handleConfirmCaller, rowObj.householdId)
                        }
                        {
                            assisterName &&
                            TooltipUser('screenpop', assisterName, rowObj.assister, 'assister', ++tempIndex, rowObj.externalCaseId,  confirmedCaller, handleConfirmCaller, rowObj.householdId)
                        }
                    </td>
                    <td>

                        {
                            authRepName &&
                            TooltipUser('screenpop', authRepName, rowObj.authRep, 'authRep', ++tempIndex, rowObj.externalCaseId)
                        }
                    </td>
                    <td>
                        <button className='usa-button gi-button gi-button__primary' onClick={(e) => handleGoToHouseHold(rowObj.householdId, e)}>
                            <FormattedMessage id='button.screenpop.view_member'/>
                        </button>
                    </td>

                </Fragment>

            );
        };
        //end of user row function
        //************************************************************


        //return statement for table body
        return (
            <tbody>
                {filteredUserData.map((item, index) => (
                    <tr key={`userRow-data-${index}`}>
                        { userRow(item,index) }
                    </tr>)
                )
                }
            </tbody>
        );

    };
    //end of table body function
    //************************************************************

    //return statement for table of results component
    return(
        <table className='usa-table--borderless usa-table gi-usa-table '>
            { tableHeader() }
            { tableBody(userObj) }
        </table>
    );
};
//end of TableofResults component
//************************************************************

export default ScreenpopTable;